var _circle, _line, _line2, _line3, _line4, _line5, _line6, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 148 44",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Spoke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    stroke: "#D6A319",
    strokeWidth: 1.8,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 22,
    y2: 4,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 37.6,
    y2: 13,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 37.6,
    y2: 31,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 22,
    y2: 40,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 6.4,
    y2: 31,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 6.4,
    y2: 13,
    stroke: "#D6A319",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 3.5,
    fill: "#D6A319"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 29,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 21,
    fontWeight: 700,
    letterSpacing: -0.4,
    fill: "#FFFFFF"
  }, "Spoke")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.edf6e8d41a16ff95798ca4dbf3d1f0d5.svg";
export { ForwardRef as ReactComponent };